/**
 * Created by Andromeda on 11/19/16.
 */
'use strict';

//users
require('angular-jwt');


// WEBPACK FOOTER //
// ./packages/custom/users/public/index.js